import styled from "styled-components";

export const Container = styled.div`
  margin: 25px 0;
`

